
import React, { useState } from 'react';
import { useUser } from '../contexts/UserContext';
import './EditProfile.css';

const EditProfile = ({ onClose }) => {
  const { user, updateUser } = useUser();
  
  // 预定义颜色选项
  const colorOptions = [
    '#4a90e2', '#f39c12', '#2ecc71', '#e74c3c', 
    '#9b59b6', '#1abc9c', '#d35400', '#3498db'
  ];
  
  const [formData, setFormData] = useState({
    name: user.name || '',
    bio: user.bio || '',
    email: user.email || '',
    position: user.position || '',
    location: user.location || '',
    joinDate: user.joinDate || '',
    techStack: [...(user.techStack || [])],
    skills: [...(user.skills || [])],
    socialMedia: user.socialMedia || '',
    avatar: user.avatar || '',
    avatarColor: user.avatarColor || '#4a90e2'
  });
  
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [tempSkill, setTempSkill] = useState('');
  const [techName, setTechName] = useState('');
  const [techLevel, setTechLevel] = useState(50);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleColorSelect = (color) => {
    setFormData(prev => ({
      ...prev,
      avatarColor: color
    }));
  };

  const handleAvatarUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData(prev => ({
          ...prev,
          avatar: event.target.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClearAvatar = () => {
    setFormData(prev => ({
      ...prev,
      avatar: ''
    }));
  };

  const handleAddSkill = (e) => {
    e.preventDefault();
    if (tempSkill.trim() && !formData.skills.includes(tempSkill.trim())) {
      setFormData(prev => ({
        ...prev,
        skills: [...prev.skills, tempSkill.trim()]
      }));
      setTempSkill('');
    }
  };

  const handleRemoveSkill = (index) => {
    setFormData(prev => ({
      ...prev,
      skills: prev.skills.filter((_, i) => i !== index)
    }));
  };

  const handleAddTech = () => {
    if (techName.trim()) {
      setFormData(prev => ({
        ...prev,
        techStack: [...prev.techStack, {
          name: techName.trim(),
          level: techLevel
        }]
      }));
      setTechName('');
      setTechLevel(50);
    }
  };

  const handleRemoveTech = (index) => {
    setFormData(prev => ({
      ...prev,
      techStack: prev.techStack.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateUser(formData);
      setMessageType('success');
      setMessage('个人信息更新成功！');
      
      // 2秒后自动关闭模态框
      setTimeout(() => {
        if (onClose) onClose();
      }, 2000);
    } catch (error) {
      setMessageType('error');
      setMessage('更新失败，请重试');
    }
  };

  const handleReset = () => {
    setFormData({
      name: user.name || '',
      bio: user.bio || '',
      email: user.email || '',
      position: user.position || '',
      location: user.location || '',
      joinDate: user.joinDate || '',
      techStack: [...(user.techStack || [])],
      skills: [...(user.skills || [])],
      socialMedia: user.socialMedia || '',
      avatar: user.avatar || '',
      avatarColor: user.avatarColor || '#4a90e2'
    });
    setMessage('');
  };

  return (
    <>
      {/* 模态框头部 */}
      <div className="modal-header">
        <h2>编辑个人信息</h2>
        <button className="close-btn" onClick={onClose}>
          ×
        </button>
      </div>

      <div className="modal-content">
        <div className="edit-profile">
          {message && (
            <div className={`message ${messageType}`}>
              {message}
            </div>
          )}
          
          <form className="edit-form" onSubmit={handleSubmit}>
            {/* 个人信息部分 */}
            <div className="form-section">
              <h3>基本信息</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="name">姓名</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="请输入您的姓名"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="bio">个人简介</label>
                  <textarea
                    id="bio"
                    name="bio"
                    value={formData.bio}
                    onChange={handleInputChange}
                    placeholder="介绍一下自己吧"
                    rows="3"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">邮箱</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="请输入邮箱地址"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="position">职位</label>
                  <input
                    type="text"
                    id="position"
                    name="position"
                    value={formData.position}
                    onChange={handleInputChange}
                    placeholder="请输入您的职位"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="location">位置</label>
                  <input
                    type="text"
                    id="location"
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    placeholder="请输入您所在的城市"
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="socialMedia">社交媒体</label>
                  <input
                    type="text"
                    id="socialMedia"
                    name="socialMedia"
                    value={formData.socialMedia}
                    onChange={handleInputChange}
                    placeholder="请输入社交媒体链接"
                  />
                </div>
              </div>
            </div>
            
            {/* 头像设置部分 */}
            <div className="form-section">
              <h3>头像设置</h3>
              <div className="avatar-edit-container">
                <div className="avatar-preview-container">
                  <div className="avatar-preview">
                    {formData.avatar ? (
                      <img 
                        src={formData.avatar} 
                        alt="头像预览" 
                        className="avatar-preview-image"
                      />
                    ) : (
                      <div 
                        className="avatar-preview-circle"
                        style={{ backgroundColor: formData.avatarColor }}
                      >
                        {formData.name ? formData.name.charAt(0).toUpperCase() : '?'}
                      </div>
                    )}
                  </div>
                  <div className="avatar-actions">
                    <label className="avatar-upload-btn">
                      上传头像
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleAvatarUpload}
                        style={{ display: 'none' }}
                      />
                    </label>
                    {formData.avatar && (
                      <button 
                        type="button" 
                        className="avatar-clear-btn"
                        onClick={handleClearAvatar}
                      >
                        清除头像
                      </button>
                    )}
                  </div>
                </div>
                
                <div className="avatar-url-section">
                  <div className="form-group">
                    <label htmlFor="avatar">头像URL</label>
                    <input
                      type="text"
                      id="avatar"
                      name="avatar"
                      value={formData.avatar}
                      onChange={handleInputChange}
                      placeholder="或者直接输入头像URL地址"
                    />
                    <p className="url-hint">支持图片链接或Base64格式</p>
                  </div>
                  
                  <div className="color-selector">
                    <label>头像背景色</label>
                    <div className="color-options">
                      {colorOptions.map((color, index) => (
                        <button
                          key={index}
                          type="button"
                          className={`color-option ${formData.avatarColor === color ? 'selected' : ''}`}
                          style={{ backgroundColor: color }}
                          onClick={() => handleColorSelect(color)}
                        />
                      ))}
                    </div>
                    <div className="custom-color">
                      <label htmlFor="customColor">自定义颜色：</label>
                      <input
                        type="color"
                        id="customColor"
                        value={formData.avatarColor}
                        onChange={(e) => handleColorSelect(e.target.value)}
                        className="color-picker"
                      />
                      <span className="color-value">{formData.avatarColor}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* 技术栈部分 */}
            <div className="form-section">
              <div className="section-header">
                <h3>技术栈</h3>
                <button 
                  type="button" 
                  className="add-btn"
                  onClick={handleAddTech}
                >
                  添加技术
                </button>
              </div>
              
              {formData.techStack.map((tech, index) => (
                <div key={index} className="tech-item">
                  <div className="tech-inputs">
                    <input
                      type="text"
                      value={tech.name}
                      onChange={(e) => {
                        const newTechStack = [...formData.techStack];
                        newTechStack[index].name = e.target.value;
                        setFormData(prev => ({ ...prev, techStack: newTechStack }));
                      }}
                      className="tech-name-input"
                      placeholder="技术名称"
                    />
                    <div className="tech-level-container">
                      <span className="level-label">熟练度：{tech.level}%</span>
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={tech.level}
                        onChange={(e) => {
                          const newTechStack = [...formData.techStack];
                          newTechStack[index].level = parseInt(e.target.value);
                          setFormData(prev => ({ ...prev, techStack: newTechStack }));
                        }}
                        className="tech-level-slider"
                      />
                    </div>
                    <button
                      type="button"
                      className="remove-tech-btn"
                      onClick={() => handleRemoveTech(index)}
                    >
                      删除
                    </button>
                  </div>
                </div>
              ))}
              
              <div className="tech-item" style={{ background: '#f8f9fa', padding: '1rem' }}>
                <div className="tech-inputs">
                  <input
                    type="text"
                    value={techName}
                    onChange={(e) => setTechName(e.target.value)}
                    className="tech-name-input"
                    placeholder="输入新技能名称"
                  />
                  <div className="tech-level-container">
                    <span className="level-label">熟练度：{techLevel}%</span>
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value={techLevel}
                      onChange={(e) => setTechLevel(parseInt(e.target.value))}
                      className="tech-level-slider"
                    />
                  </div>
                </div>
              </div>
            </div>
            
            {/* 技能标签部分 */}
            <div className="form-section">
              <div className="section-header">
                <h3>技能标签</h3>
                <button 
                  type="button" 
                  className="add-btn"
                  onClick={handleAddSkill}
                >
                  添加技能
                </button>
              </div>
              
              <div className="skills-input-container">
                <div className="skill-input-group">
                  <input
                    type="text"
                    value={tempSkill}
                    onChange={(e) => setTempSkill(e.target.value)}
                    className="skill-input"
                    placeholder="输入技能标签"
                  />
                </div>
                
                {formData.skills.length > 0 && (
                  <div className="skills-tags">
                    {formData.skills.map((skill, index) => (
                      <div key={index} className="skill-tag-item">
                        <span className="skill-tag">{skill}</span>
                        <button
                          type="button"
                          className="remove-skill-btn"
                          onClick={() => handleRemoveSkill(index)}
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            
            {/* 表单操作按钮 */}
            <div className="form-actions">
              <button 
                type="button" 
                className="cancel-btn"
                onClick={onClose}
              >
                取消
              </button>
              <button 
                type="button" 
                className="reset-btn"
                onClick={handleReset}
              >
                重置
              </button>
              <button 
                type="submit" 
                className="save-btn"
              >
                保存更改
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditProfile;